import api from './api'

export const resourceService = {
  // Get all resources
  getAll: async () => {
    const response = await api.get('/resources')
    // Backend now returns array directly, not wrapped in {resources: []}
    return response.data || []
  },

  // Download a resource file
  download: async (resourceId) => {
    const response = await api.get(`/resources/${resourceId}/download`, {
      responseType: 'blob',
    })
    return response
  },

  // View a resource (get content)
  view: async (resourceId) => {
    const response = await api.get(`/resources/${resourceId}/view`)
    return response.data
  },
}
